import { jsx as _jsx } from "react/jsx-runtime";
import DraggableComponent from "../DraggableComponent";
const DraggableList = ({ item: { props, id, children }, elementId, ...rest }) => {
    return (_jsx("ul", { className: props?.className, "editor-key": id, "editor-type": "list", ...rest, children: children.map((c) => (_jsx(DraggableComponent, { item: c, elementId: elementId }, c.id))) }));
};
export default DraggableList;
//# sourceMappingURL=DraggableList.js.map